package features.attendance.ui

import kotlinx.html.*
import kotlinx.html.js.onClickFunction
import kotlinx.html.js.onChangeFunction
import org.w3c.dom.HTMLElement
import features.teams.domain.Team
import AppState
import shared.ui.ModalManager

object AttendanceTab {
    fun render(parent: DIV, team: Team) {
        val currentUserId = AppState.currentUser?.id ?: ""
        val userRole = features.attendance.helpers.AttendanceHelpers.getUserRole(currentUserId, team.id)
        val isAdminOrOwner = userRole == "owner" || userRole == "admin"
        
        console.log("🔍 log-attendance: AttendanceTab.render() called")
        console.log("🔍 log-attendance: Team ID:", team.id)
        console.log("🔍 log-attendance: Current user ID:", currentUserId)
        console.log("🔍 log-attendance: AppState.attendance[${team.id}] size:", AppState.attendance[team.id]?.size)
        
        // Get filtered records based on user role
        var records = features.attendance.helpers.AttendanceHelpers.getFilteredAttendanceRecords(
            team.id,
            currentUserId
        )
        
        // Initialize default filter (Current Month) if not set
        if (AppState.attendanceFilterStartDate == null || AppState.attendanceFilterEndDate == null) {
             val today = kotlin.js.Date()
             val firstDay = kotlin.js.Date(today.getFullYear(), today.getMonth(), 1)
             val lastDay = kotlin.js.Date(today.getFullYear(), today.getMonth() + 1, 0)
             
             val f_yyyy = firstDay.getFullYear()
             val f_mm = (firstDay.getMonth() + 1).toString().padStart(2, '0')
             val f_dd = firstDay.getDate().toString().padStart(2, '0')
             
             val l_yyyy = lastDay.getFullYear()
             val l_mm = (lastDay.getMonth() + 1).toString().padStart(2, '0')
             val l_dd = lastDay.getDate().toString().padStart(2, '0')
             
             AppState.attendanceFilterStartDate = "$f_yyyy-$f_mm-$f_dd"
             AppState.attendanceFilterEndDate = "$l_yyyy-$l_mm-$l_dd"
        }

        // Apply Date Range Filter 
        // Note: String comparison works for YYYY-MM-DD format
        if (AppState.attendanceFilterStartDate != null) {
            records = records.filter { it.date >= AppState.attendanceFilterStartDate!! }
        }
        if (AppState.attendanceFilterEndDate != null) {
            records = records.filter { it.date <= AppState.attendanceFilterEndDate!! }
        }
        
        console.log("🔍 log-attendance: Filtered records count:", records.size)
        console.log("🔍 log-attendance: Records:", records)
        
        parent.div {
            div("flex justify-between items-center mb-6") {
                h3("text-2xl font-bold") { +"Daily Attendance" }
                div("flex gap-3") {
                    // Export CSV Button (Phase 3 Placeholder)
                    /*
                    if (isAdminOrOwner) {
                         button(classes = "bg-dark-700 hover:bg-dark-600 text-slate-300 px-4 py-2 rounded-lg font-medium transition flex items-center gap-2 border border-slate-600") {
                            onClickFunction = { console.log("Export CSV clicked") }
                            span { +"📥" }
                            +"Export CSV"
                        }
                    }
                    */

                    button(classes = "bg-slate-700 hover:bg-slate-600 text-white px-4 py-2 rounded-lg font-medium transition flex items-center gap-2 border border-slate-600") {
                        id = "refresh-attendance-btn"
                        onClickFunction = {
                            console.log("🔍 log-attendance: Refresh button clicked")
                            val currentUserId = AppState.currentUser?.id ?: ""
                            val userRole = features.attendance.helpers.AttendanceHelpers.getUserRole(currentUserId, team.id)
                            
                            console.log("🔍 log-attendance: Reloading attendance from Firebase...")
                            
                            // Disable button during reload
                            val btn = kotlinx.browser.document.getElementById("refresh-attendance-btn") as? org.w3c.dom.HTMLButtonElement
                            btn?.disabled = true
                            btn?.textContent = "⏳ Refreshing..."
                            
                            features.attendance.data.AttendanceRepository.getAttendanceRecordsForUser(team.id, currentUserId, userRole)
                                .then { attendanceRecords ->
                                    console.log("✅ log-attendance: Refresh successful - Loaded ${attendanceRecords.size} records")
                                    AppState.attendance[team.id] = attendanceRecords.toMutableList()
                                    
                                    // Re-render the page
                                    Router.render()
                                    
                                    // Re-enable button
                                    btn?.disabled = false
                                    btn?.textContent = "🔄 Refresh"
                                }
                                .catch { error ->
                                    console.error("❌ log-attendance: Refresh failed:", error)
                                    btn?.disabled = false
                                    btn?.textContent = "🔄 Refresh"
                                    kotlinx.browser.window.alert("Failed to refresh attendance data")
                                }
                        }
                        span { +"🔄" }
                        +"Refresh"
                    }
                    // Manage Holidays - Owner only
                    if (userRole == "owner") {
                        button(classes = "bg-dark-700 hover:bg-dark-600 text-white px-4 py-2 rounded-lg font-medium transition flex items-center gap-2 border border-slate-600") {
                            onClickFunction = {
                                ModalManager.show("manage-holidays-modal")
                                // Refresh holidays list when modal opens
                                kotlinx.browser.window.setTimeout({
                                    features.attendance.ui.modals.ManageHolidaysModal.refreshHolidaysList()
                                }, 100)
                            }
                            span { +"🗓️" }
                            +"Manage Holidays"
                        }
                    }
                    // Clock In/Out button
                    val currentUserId = AppState.currentUser?.id ?: ""
                    val attendanceStatus = features.attendance.helpers.AttendanceHelpers.getAttendanceStatus(currentUserId, team.id)
                    
                    when (attendanceStatus) {
                        "not_clocked_in" -> {
                            button(classes = "bg-brand-cyan hover:bg-brand-green text-white px-4 py-2 rounded-lg font-medium transition flex items-center gap-2") {
                                onClickFunction = { ModalManager.show("clock-in-modal") }
                                span { +"⏱️" }
                                +"Clock In"
                            }
                        }
                        "clocked_in" -> {
                            button(classes = "bg-violet-500 hover:bg-violet-600 text-white px-4 py-2 rounded-lg font-medium transition flex items-center gap-2") {
                                onClickFunction = { 
                                    // Set clock-out mode
                                    kotlinx.browser.window.asDynamic().isClockOutMode = true
                                    ModalManager.show("clock-in-modal")
                                }
                                span { +"⏱️" }
                                +"Clock Out"
                            }
                        }
                        "clocked_out" -> {
                            div(classes = "bg-emerald-500/20 text-emerald-400 px-4 py-2 rounded-lg font-medium flex items-center gap-2") {
                                span { +"✓" }
                                +"Completed Today"
                            }
                        }
                    }
                }
            }

            // === 🔍 FILTER SECTION START ===
            div("bg-dark-800 p-4 rounded-xl border border-dark-700 mb-6") {
                div("flex flex-wrap items-end gap-4") {
                    // Date Range Pickers
                    div("flex flex-col gap-1") {
                        label("text-sm text-slate-400 font-medium") { +"Start Date" }
                        input(type = InputType.date, classes = "bg-dark-900 border border-dark-600 text-white px-3 py-2 rounded-lg focus:outline-none focus:border-brand-cyan transition") {
                            value = AppState.attendanceFilterStartDate ?: ""
                            onChangeFunction = { event ->
                                val target = event.target as org.w3c.dom.HTMLInputElement
                                AppState.attendanceFilterStartDate = target.value.ifEmpty { null }
                                Router.render()
                            }
                        }
                    }
                    div("flex flex-col gap-1") {
                        label("text-sm text-slate-400 font-medium") { +"End Date" }
                        input(type = InputType.date, classes = "bg-dark-900 border border-dark-600 text-white px-3 py-2 rounded-lg focus:outline-none focus:border-brand-cyan transition") {
                            value = AppState.attendanceFilterEndDate ?: ""
                            onChangeFunction = { event ->
                                val target = event.target as org.w3c.dom.HTMLInputElement
                                AppState.attendanceFilterEndDate = target.value.ifEmpty { null }
                                Router.render()
                            }
                        }
                    }

                    // Quick Filter Buttons
                    div("flex gap-2") {
                        button(classes = "bg-dark-700 hover:bg-dark-600 text-slate-300 text-sm px-3 py-2 rounded-lg border border-dark-600 transition") {
                            onClickFunction = {
                                val today = kotlin.js.Date()
                                val yyyy = today.getFullYear()
                                val mm = (today.getMonth() + 1).toString().padStart(2, '0')
                                val dd = today.getDate().toString().padStart(2, '0')
                                val todayStr = "$yyyy-$mm-$dd"
                                AppState.attendanceFilterStartDate = todayStr
                                AppState.attendanceFilterEndDate = todayStr
                                Router.render()
                            }
                            +"Today"
                        }
                        button(classes = "bg-dark-700 hover:bg-dark-600 text-slate-300 text-sm px-3 py-2 rounded-lg border border-dark-600 transition") {
                            onClickFunction = {
                                val today = kotlin.js.Date()
                                val firstDay = kotlin.js.Date(today.getFullYear(), today.getMonth(), 1)
                                val lastDay = kotlin.js.Date(today.getFullYear(), today.getMonth() + 1, 0)
                                
                                val f_yyyy = firstDay.getFullYear()
                                val f_mm = (firstDay.getMonth() + 1).toString().padStart(2, '0')
                                val f_dd = firstDay.getDate().toString().padStart(2, '0')
                                
                                val l_yyyy = lastDay.getFullYear()
                                val l_mm = (lastDay.getMonth() + 1).toString().padStart(2, '0')
                                val l_dd = lastDay.getDate().toString().padStart(2, '0')
                                
                                AppState.attendanceFilterStartDate = "$f_yyyy-$f_mm-$f_dd"
                                AppState.attendanceFilterEndDate = "$l_yyyy-$l_mm-$l_dd"
                                Router.render()
                            }
                            +"This Month"
                        }
                        button(classes = "bg-dark-700 hover:bg-dark-600 text-slate-300 text-sm px-3 py-2 rounded-lg border border-dark-600 transition") {
                             onClickFunction = {
                                val today = kotlin.js.Date()
                                val firstDay = kotlin.js.Date(today.getFullYear(), today.getMonth() - 1, 1)
                                val lastDay = kotlin.js.Date(today.getFullYear(), today.getMonth(), 0)
                                
                                val f_yyyy = firstDay.getFullYear()
                                val f_mm = (firstDay.getMonth() + 1).toString().padStart(2, '0')
                                val f_dd = firstDay.getDate().toString().padStart(2, '0')
                                
                                val l_yyyy = lastDay.getFullYear()
                                val l_mm = (lastDay.getMonth() + 1).toString().padStart(2, '0')
                                val l_dd = lastDay.getDate().toString().padStart(2, '0')
                                
                                AppState.attendanceFilterStartDate = "$f_yyyy-$f_mm-$f_dd"
                                AppState.attendanceFilterEndDate = "$l_yyyy-$l_mm-$l_dd"
                                Router.render()
                            }
                            +"Last Month"
                        }
                         button(classes = "bg-dark-700 hover:bg-dark-600 text-slate-300 text-sm px-3 py-2 rounded-lg border border-dark-600 transition ml-2") {
                            onClickFunction = {
                                AppState.attendanceFilterStartDate = null
                                AppState.attendanceFilterEndDate = null
                                Router.render()
                            }
                            +"Clear"
                        }
                    }
                }
            }
            // === FILTER SECTION END ===
            
            // Show filtered count
            if (records.isNotEmpty()) {
                div("mb-4 text-slate-400 text-sm font-medium flex items-center gap-2") {
                    span("bg-dark-700 px-2 py-0.5 rounded text-white") { +"${records.size}" }
                    +"records found"
                }
            }
            
            if (records.isEmpty()) {
                div("text-center py-12") {
                    img(src = "/images/empty-states/no-attendance.png", alt = "No attendance records") {
                        classes = setOf("w-64", "h-64", "mx-auto", "mb-6")
                    }
                    h3("text-xl font-bold mb-2") { +"No Attendance Records Yet" }
                    p("text-slate-400") { +"Start tracking attendance by clocking in" }
                }
            } else {
                // Wrapper with horizontal scroll for mobile
                div("bg-dark-800 rounded-2xl border border-dark-700 overflow-x-auto") {
                    table("min-w-max w-full text-left border-collapse") {
                        thead {
                            tr("bg-dark-900/50 text-slate-400 border-b border-dark-700") {
                                th {
                                    classes = setOf("p-4", "font-medium")
                                    +"Date"
                                }
                                // Member column only for admin/owner
                                if (isAdminOrOwner) {
                                    th {
                                        classes = setOf("p-4", "font-medium")
                                        +"Member"
                                    }
                                }
                                th {
                                    classes = setOf("p-4", "font-medium")
                                    +"Photo"
                                }
                                th {
                                    classes = setOf("p-4", "font-medium")
                                    +"Clock In"
                                }
                                th {
                                    classes = setOf("p-4", "font-medium")
                                    +"Clock Out"
                                }
                                th {
                                    classes = setOf("p-4", "font-medium")
                                    +"Status"
                                }
                                th {
                                    classes = setOf("p-4", "font-medium")
                                    +"Location"
                                }
                            }
                        }
                        tbody {
                            records.forEach { record ->
                                val member = AppState.members[team.id]?.find { it.id == record.userId }
                                val statusClass = when (record.status) {
                                    "Present" -> "bg-emerald-500/10 text-emerald-400"
                                    "Late" -> "bg-amber-500/10 text-amber-400"
                                    "Absent" -> "bg-red-500/10 text-red-400"
                                    else -> "bg-slate-500/10 text-slate-400"
                                }
                                
                                tr("hover:bg-dark-700/30 transition border-b border-dark-700 last:border-0") {
                                    td("p-4 text-white font-medium") { +record.date }
                                    // Member column only for admin/owner
                                    if (isAdminOrOwner) {
                                        td("p-4 text-slate-300") { +(member?.name ?: "Unknown") }
                                    }
                                    // Photo column
                                    td("p-4") {
                                        if (record.checkInPhoto != null) {
                                            img {
                                                src = record.checkInPhoto
                                                classes = setOf("w-12", "h-12", "rounded-lg", "object-cover", "cursor-pointer", "hover:ring-2", "hover:ring-brand-cyan", "transition")
                                                attributes["onclick"] = "window.showPhotoPreview('" + record.checkInPhoto + "', '" + (record.checkOutPhoto ?: "") + "', '" + record.date + "', '" + (member?.name ?: "Unknown") + "')"
                                            }
                                        } else {
                                            div("w-12 h-12 rounded-lg bg-dark-700 flex items-center justify-center text-slate-500 text-xs") {
                                                +"No Photo"
                                            }
                                        }
                                    }
                                    td("p-4 text-slate-300") { +record.checkIn }
                                    td("p-4 text-slate-300") { +record.checkOut }
                                    td("p-4") {
                                        span("px-2 py-1 rounded text-xs font-bold $statusClass") {
                                            +record.status
                                        }
                                    }
                                    td("p-4") {
                                        button(classes = "bg-brand-cyan/10 hover:bg-brand-cyan/20 text-brand-cyan px-3 py-1 rounded-lg text-xs font-medium transition flex items-center gap-1") {
                                            attributes["data-location"] = record.location
                                            onClickFunction = {
                                                features.attendance.ui.modals.LocationPreviewModal.show(record.location)
                                            }
                                            span { +"🗺️" }
                                            +"View Map"
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
